import styled from "styled-components/native";
import { spacers } from "~/styles/theme";

export const ButtonContainer = styled.View`
  margin-top: ${spacers.ss8};
`;
